import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

const SellerApplicationBusinessConfirmation: FC = () => (
    <div className={classnames(dibsCss.minH600px, dibsCss.textCenter)}>
        <div className={dibsCss.sassyFontHeader}>
            <FormattedMessage
                defaultMessage="Thank you for your application!"
                id="SellerApplicationForm.businessDetails.header"
            />
        </div>
        <div className={classnames(dibsCss.mtMedium, dibsCss.sassyFontBody)}>
            <FormattedMessage
                defaultMessage="Please note, that we do have a waitlist to join our seller community.  We will only contact you if your application is approved or if we need more details."
                id="SellerApplicationForm.businessDetails.confirmationText"
            />
        </div>
    </div>
);

export default SellerApplicationBusinessConfirmation;
